'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Typography_web = require('../Typography/Typography.web.cjs');
var Divider_web_styles = require('./Divider.web.styles.cjs');

/**
 * Divider component used to separate content
 *
 * {@link https://aviary.fullscript.io/latest/components/divider/web-3MdAHRvK-3MdAHRvK | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Divider/Divider.web.tsx | View in GitLab}
 *
 * @scope Core
 *
 */ const Divider = ({ labelContent, customCss, ...rest })=>{
    const dividerStyles = [
        Divider_web_styles.divider,
        customCss
    ];
    const labelDividerStyles = [
        Divider_web_styles.labelDivider,
        customCss
    ];
    if (labelContent) {
        return /*#__PURE__*/ jsxRuntime.jsx("div", {
            role: "separator",
            css: labelDividerStyles,
            "data-testid": "aviary-divider",
            ...rest,
            children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                colorIntensity: "subtle",
                variant: "footnote",
                customCss: Divider_web_styles.label,
                children: labelContent
            })
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx("hr", {
        "data-testid": "aviary-divider",
        css: dividerStyles,
        ...rest
    });
};
Divider.displayName = "Divider";

exports.Divider = Divider;
//# sourceMappingURL=Divider.web.cjs.map
